import { createFileRoute } from '@tanstack/react-router'

import { NotificationsPage } from '#/modules/communication/notifications-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/notifications')({
  component: NotificationsPage,
  validateSearch: validateListSearch,
})
